<template>
  <div>
    <div class="uploader ready">
      <p 
        v-if="showError" 
        ref="errorText" 
        class="text-danger mb-2" 
        tabindex="0"
      >
        {{errorMsg || `Upload at least ${minCount} photo${minCount > 1 ? 's' : ''} of the vehicle`}}
      </p> 

      <div
        class="upload-drop-site"
        :class="dragClass"
        :disabled="disabled"
      >
        <div
          class="handler"
          tabindex="0"
          @dragover.prevent.stop="setActive"
          @dragenter.prevent.stop="setActive"
          @dragleave.prevent.stop="usnetActive"
          @dragend.prevent.stop="usnetActive"
          @drop.prevent.stop="onDropFiles"
          @drag.prevent.stop
          @dragstart.prevent.stop
          @click="$refs.fileInput.click()"
        >
          <input
            ref="fileInput"
            accept="application/pdf"
            type="file"
            autocomplete="off"
            tabindex="-1"
            style="display: none"
            single
            
            @input="onInputFiles"
          >
          <svg
            class="dropzone-icon"
            width="25"
            height="20"
            viewBox="0 0 25 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.0054 13.998L12.0054 9.99805L8.00537 13.998"
              stroke="#6BCAEE"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12.0054 9.99805V18.998"
              stroke="#6BCAEE"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20.3954 16.3878C22.4018 15.2939 23.4113 12.979 22.8477 10.7645C22.284 8.54988 20.2906 6.99927 18.0054 6.99777H16.7454C15.9165 3.79158 13.1979 1.42754 9.90765 1.05187C6.61742 0.676188 3.43585 2.36655 1.90553 5.30336C0.375206 8.24017 0.812525 11.8163 3.00545 14.2978"
              stroke="#6BCAEE"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16.0054 13.998L12.0054 9.99805L8.00537 13.998"
              stroke="#6BCAEE"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p data-abbr="Tap to select photos">
            <span>Click to select pdf, or drag and drop here</span>
          </p>
        </div>
      </div>
    </div>

    <div
      v-if="errorList.length > 0"
      class="text-danger mt-3"
    >
      <div
        v-for="(error, idx) in errorList"
        :key="idx"
      >
        {{ error }}
      </div>
    </div>

    <ul
      v-if="photos.length > 0"
      class="upload-picks"
    >
      <li
        v-for="(photo) in photos"
        :key="`${photo.id}`"
        class="preview"
      >
        <VPdfPreview 
          :pdfUrl="photo.file || photo.url"
          :loading="photo.loading"
        />
        <!-- <button
          v-if="!photo.loading"
          type="button"
          class="btn remove photo-input__remove-btn"
          :class="{ 'photo-input__remove-btn_deleting': photo.deleting }"
          aria-label="Delete"
          @mouseup="removePhoto(photo)"
          :disabled="disabled"
        >
          <span class="sr-only">Delete</span>
        </button> -->
      </li>
    </ul>
  </div>
</template>
<script>
import {
  checkImageOrFail, checkPdfOrFail
} from '@/utils/validation/image'
import VPdfPreview from './VPdfPreview'
import {
  createAuctionManagerMixin,
  auctionManagerStore
} from '@/mixins/auctionsManagerMixin'
import ModalType from '@/utils/dictionaries/modalType'

export default {
  name: 'VPdfInput',

  components: {
    VPdfPreview
  },

  mixins: [createAuctionManagerMixin()],

  props: {
    carId: {
      type: Number,
    },
    name: {
      type: String,
      default: ''
    },
    carHistoryReport: {
      type: String,
    },
    minCount: {
      type: Number,
      default: 1
    },
    loadedPhotos: {
      type: Array,
      default: () => ([])
    },
    disabled: Boolean,
    errorMsg: String,
  },

  data: () => ({
    isActiveDragEvent: false,
    photos: [],
    errorList: [],
    allFilesCount: 1,
    morePhotos: 0,
    showError: false,
  }),
  computed: {
    dragClass() {
      return {
        active: this.isActiveDragEvent
      }
    }
  },

  created() {
    console.log("this.loadedPhotos",this.loadedPhotos)
    if (Array.isArray(this.loadedPhotos)) {
      this.photos = this.loadedPhotos
        .filter(p => p.url !== 'null')
        .map(p => ({
            ...p,
            loading: false,
            deleting: false,
            result: { ...p.result }
        }));
      }
  },

  methods: {
    hasErrors() {
      this.showError = this.photos.length < this.minCount

      if (this.showError) {
        this.morePhotos = this.minCount - this.photos.length
        this.$nextTick(() => {
          this.$refs.errorText.focus()
        })
      }

      return this.showError
    },

    hasLoadingPhotos() {
      return this.photos.some(p => p.loading)
    },

    setActive() {
      this.isActiveDragEvent = true
    },

    usnetActive() {
      this.isActiveDragEvent = false
    },

    onInputFiles(e) {
      this.uploadFiles(e.target.files)
    },

    getFileId() {
      this.allFilesCount += 1
      return this.allFilesCount
    },

    async uploadFiles(files) {    
      if (this.disabled) return 
      for (let idx = 0; idx < Array.from(files).length; idx++) {
        try {
          checkPdfOrFail(files[idx])
          const newPhoto = {
            id: this.getFileId(),
            file: files[idx],
            loading: true,
            deleting: false,
            result: null
          }
          this.photos.push(newPhoto)
          this[auctionManagerStore.actionTypes.ACTION_ADD_PDF_TO_CAR]({ carId: this.carId, file: files[idx], name: 'historyReport'  })
            .then(({ arrId, data }) => {
              const index = 0
              this.photos = []
              this.$emit('input', data.url);
              this.photos.push( {url : data.url,  loading: false})
            })
            .catch((error) => {
              this.pushError(error.message)
            })

          
        } catch (error) {
          this.photos.splice(this.photos.length -1, 1)

          this.pushError(error.message)
        }
      }

      this.hasErrors()
      this.$emit('input', files)
    },

    onDropFiles(e) {
      if (e.dataTransfer.files) {
        this.uploadFiles(e.dataTransfer.files)
      }
    },

    pushError(errorText) {
      this.errorList.push(errorText)

      setTimeout(() => {
        this.removeItemFromArray(this.errorList, errorText)
      }, 5000)
    },

    async removePhoto(photo) {   
      if (this.disabled) return 
      if (!photo.result || !photo.result.id || photo.deleting) return
      const deleting = async () => {
        if (photo.deleting) return
        photo.deleting = true

        try {
          await this[auctionManagerStore.actionTypes.ACTION_REMOVE_CAR_PHOTO]({ imageId: photo.result.id })
        } catch (error) {}

        photo.deleting = false
        this.removeItemFromArray(this.photos, photo, true)

        this.$modals.close(ModalType.ConfirmationModal)
      }

      this.$modals.open(ModalType.ConfirmationModal, {
        title: 'Deletion',
        body: 'Are you sure you want to delete the photo? It will be deleted without saving.',
        buttonText: 'Delete',
        onClickButton: deleting
      })
    },

    removeItemFromArray(array, item, isPhoto) {
      const itemIndex = isPhoto ?
        array.findIndex(_item => _item.id === item.id) :
        array.indexOf(item)

      if (itemIndex >= 0) {
        array.splice(itemIndex, 1)
      }
    },
  }
}
</script>
<style>
.photo-input__remove-btn {
  z-index: 3;
}

.photo-input__remove-btn_deleting::after {
    margin-top: 0 !important;
    background: none !important;
    width: calc(100% - 4px) !important;
    height: calc(100% - 4px) !important;
    border: solid;
    border-radius: 50em;
    border-right: .25em solid white;
    animation: spinner-border .75s linear infinite;
}
</style>
